const productReadmore = () => {
    const $productDescriptionHasMore = document.querySelector('[data-product-description-has-more]');
    if ($productDescriptionHasMore) {
        $productDescriptionHasMore.classList.add('collapse');

        const $productDescriptionShowMore = $productDescriptionHasMore.querySelector('[data-product-description-show-more]');
        if ($productDescriptionShowMore) {
            $productDescriptionShowMore.addEventListener('click', (e) => {
                e.preventDefault();

                $productDescriptionHasMore.classList.toggle('collapse');
                
                // Back to top on 'Voir moins'
                if ($productDescriptionHasMore.classList.contains('collapse')) {
                    // const scrollTo = $productDescriptionHasMore.offsetTop || 0;
                    const scrollTo = 0;
                    window.scrollTo({ top: scrollTo, behavior: 'smooth' });
                }
            });
        }
    }
}

const productStickyAddToCart = () => {
    let options = {
        threshold: 0.5
    };

    let observer = new IntersectionObserver(
        function (entries, observer) {
            handleIntersect(entries, observer); 
        }, 
        options
    );

    const $productAddToCart = document.querySelector('[data-product-form] [data-product-atc]');
    const $productStickyBanner = document.querySelector('#product-sticky-banner');
    if ($productAddToCart && $productStickyBanner) {
        observer.observe($productAddToCart);
    }

    const $fakeAddToCart = $productStickyBanner.querySelector('[data-product-atc]');
    if ($fakeAddToCart) {
        $fakeAddToCart.addEventListener('click', (e) => {
            e.preventDefault();
            $productAddToCart.click();
        });
    }
    
    const $productQtyMinus = document.querySelector('[data-product-form] button[data-quantity-minus]');
    const $fakeQtyMinus = $productStickyBanner.querySelector('button[data-quantity-minus]');
    if ($productQtyMinus && $fakeQtyMinus) {
        $fakeQtyMinus.addEventListener('click', (e) => {
            e.preventDefault();
            $productQtyMinus.click();
        });
    }

    const $productQtyPlus = document.querySelector('[data-product-form] button[data-quantity-plus]');
    const $fakeQtyPlus = $productStickyBanner.querySelector('button[data-quantity-plus]');
    if ($productQtyPlus && $fakeQtyPlus) {
        $fakeQtyPlus.addEventListener('click', (e) => {
            e.preventDefault();
            $productQtyPlus.click();
        });
    }

    const $productQtyInput = document.querySelector('[data-product-form] [data-quantity-input]');
    const $fakeQtyInput = $productStickyBanner.querySelector('[data-quantity-input]');
    if ($productQtyInput && $fakeQtyInput) {
        window.addEventListener('addtocartqty:update', (e) => {
            e.preventDefault();
            $fakeQtyInput.value = $productQtyInput.value;
        });

        $fakeQtyInput.addEventListener('change', (e) => {
            e.preventDefault();
            $productQtyInput.value = $fakeQtyInput.value;
            $productQtyInput.change();
        });
    }

    const handleIntersect = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                $productStickyBanner.classList.remove('product-sticky-banner--visible');
            } else {
                $productStickyBanner.classList.add('product-sticky-banner--visible');
                
                if(window.innerWidth < 769) {
                    if (entry.boundingClientRect.top < 0) {
                        $productStickyBanner.classList.remove('product-sticky-banner--hide-title');
                    } else {
                        $productStickyBanner.classList.add('product-sticky-banner--hide-title');
                    }
                }
            }
        });
    }

    // Hide sticky add to cart on footer
    document.addEventListener('scroll', (e) => {
        if ((window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight - 100) {
            $productStickyBanner.classList.add('product-sticky-banner--hide-on-footer');
        } else {
            $productStickyBanner.classList.remove('product-sticky-banner--hide-on-footer');
        }
    });
}

document.addEventListener('DOMContentLoaded', (event) => {
    if (document.body.classList.contains('template-product')) {
        productReadmore();
        productStickyAddToCart();
    }
});